import { render, staticRenderFns } from "./StatsBox.vue?vue&type=template&id=1a59b111&scoped=true&"
import script from "./StatsBox.vue?vue&type=script&lang=js&"
export * from "./StatsBox.vue?vue&type=script&lang=js&"
import style0 from "./StatsBox.vue?vue&type=style&index=0&id=1a59b111&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59b111",
  null
  
)

export default component.exports